var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3GarageClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 27.08L21 14.28 0 29.11V59h76V27l-36.4.08zM38 55H24v-9h-6v9H4V31.22l17-12 17 11.69V55zm34 0H42v-3h30v3zm0-7H42v-3h30v3zm0-7H42v-3h30v3zm0-7H42v-3h30v3zm-40 6h-6v-6h6v6zm-22-6h6v6h-6v-6z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Garage_closed.f9bc79e3.svg";
export { SvgE3GarageClosed as ReactComponent };